"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _tabbable = require("tabbable");
var _focusBoomerang = _interopRequireDefault(require("../../helpers/focus-boomerang"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(_ref) {
  var hasFocus = _ref.hasFocus,
    isTooltipHidden = _ref.isTooltipHidden,
    tooltipRef = _ref.tooltipRef,
    setHasFocus = _ref.setHasFocus,
    showTooltip = _ref.showTooltip;
  var focusRef = (0, _react.useRef)(new _focusBoomerang["default"]());
  (0, _react.useEffect)(function () {
    if (!showTooltip || isTooltipHidden) {
      setHasFocus(false);
      focusRef.current.check({
        isActive: false,
        wasActive: hasFocus,
        focusedWhenActive: null
      });
      return;
    }
    var firstFocusable = tooltipRef.current.querySelectorAll('[tabIndex="-1"]')[0];
    var tabbableElements = (0, _tabbable.tabbable)(tooltipRef.current);
    var firstTabbable = tabbableElements[0];
    focusRef.current.check({
      isActive: true,
      wasActive: hasFocus,
      // Set focus to the most appropriate item
      focusedWhenActive: firstFocusable || firstTabbable || tooltipRef.current
    });
    setHasFocus(true);
  }, [showTooltip, hasFocus, isTooltipHidden]);
};